import request from '@/utils/request'

/**
 * app安全综合评估（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionContractorInfoGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/contractor/info/get',
    method: 'post',
    data
  })
}

/**
 * app安全综合评估分页获取异常列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionContractorListGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/contractor/list/get',
    method: 'post',
    data
  })
}

/**
 * 承包商app数据统计，获取年异常处置未处置统计信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionContractorStatisticGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/contractor/statistic/get',
    method: 'post',
    data
  })
}

/**
 * 承包商app数据统计，获取年异常分类信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionContractorTypegroupListGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/contractor/typegroup/list/get',
    method: 'post',
    data
  })
}

/**
 * app获取异常详情（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionDetailInfoGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/detail/info/get',
    method: 'post',
    data
  })
}

/**
 * app异常处置分页获取异常列表(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionHandleListGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/handle/list/get',
    method: 'post',
    data
  })
}

/**
 * app分页获取异常（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function appExceptionListGet(data) {
  return request({
    type: 'device',
    url: 'app/exception/list/get',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-24h违规告警分析(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataHourGet(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/hour/get',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI违规告警明细表全部导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataListExport(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI违规告警明细表(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataListGet(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI违规告警明细表部分导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataListOptionExport(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI异常区域分布(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataRegionGet(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/region/get',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI违规告警总数(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataTotalGet(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/total/get',
    method: 'post',
    data
  })
}

/**
 * AI违规告警分析-AI违规告警总数(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionAiBigdataTypeGet(data) {
  return request({
    type: 'device',
    url: 'exception/ai/bigdata/type/get',
    method: 'post',
    data
  })
}

/**
 * 预警处置-预警详情（App）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferDetailGet(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/detail/get',
    method: 'post',
    data
  })
}

/**
 * 预警处置-分页列表（App）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferPageList(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/page/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-预警处置率排行（今日/7日）（App）（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferStatisticsHandleRankList(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/statistics/handle/rank/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-今日预警统计(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionBufferTodayCount(data) {
  return request({
    type: 'device',
    url: 'exception/buffer/today/count',
    method: 'post',
    data
  })
}

/**
 * 根据楼层ID，微生物运动轨迹（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionContrailGet(data) {
  return request({
    type: 'device',
    url: 'exception/contrail/get',
    method: 'post',
    data
  })
}

/**
 * 获取各食堂异常总数
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionCountListGet(data) {
  return request({
    type: 'device',
    url: 'exception/count/list/get',
    method: 'post',
    data
  })
}

/**
 * 今日/七日异常统计(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDayCount(data) {
  return request({
    type: 'device',
    url: 'exception/day/count',
    method: 'post',
    data
  })
}

/**
 * 扣分原因列表(App)(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDeductionListGet(data) {
  return request({
    type: 'device',
    url: 'exception/deduction/list/get',
    method: 'post',
    data
  })
}

/**
 * 小程序，食安监管，建议（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDeptAdvice(data) {
  return request({
    type: 'device',
    url: 'exception/dept/advice',
    method: 'post',
    data
  })
}

/**
 * 后厨食品安全情况分析（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDeptSafeAnalysis(data) {
  return request({
    type: 'device',
    url: 'exception/dept/safe/analysis',
    method: 'post',
    data
  })
}

/**
 * 获取组织总体食安情况（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDeptTotalSituation(data) {
  return request({
    type: 'device',
    url: 'exception/dept/total/situation',
    method: 'post',
    data
  })
}

/**
 * 根据设备ID获取设备异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionDeviceListGet(data) {
  return request({
    type: 'device',
    url: 'exception/device/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂总能耗异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionEnergyTotalListGet(data) {
  return request({
    type: 'device',
    url: 'exception/energy/total/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常处置信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionExplanationInfoGet(data) {
  return request({
    type: 'device',
    url: 'exception/explanation/info/get',
    method: 'post',
    data
  })
}

/**
 * 导出历史异常记录excel
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionHistoryListExcelGet(data) {
  return request({
    type: 'device',
    url: 'exception/history/list/excel/get',
    method: 'post',
    data
  })
}

/**
 * 获取历史异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionHistoryListGet(data) {
  return request({
    type: 'device',
    url: 'exception/history/list/get',
    method: 'post',
    data
  })
}

/**
 * 新增异常(ndj)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionInfoAdd(data) {
  return request({
    type: 'device',
    url: 'exception/info/add',
    method: 'post',
    data
  })
}

/**
 * 新增异常(内部接口feign调用)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionInfoInnerAdd(data) {
  return request({
    type: 'device',
    url: 'exception/info/inner/add',
    method: 'post',
    data
  })
}

/**
 * 异常更新(内部调用)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionInfoInnerUpdate(data) {
  return request({
    type: 'device',
    url: 'exception/info/inner/update',
    method: 'post',
    data
  })
}

/**
 * 异常处置（ndj）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionInfoUpdate(data) {
  return request({
    type: 'device',
    url: 'exception/info/update',
    method: 'post',
    data
  })
}

/**
 * 返回设备在规定时间内的异常个数(内部调用)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionInnerCountHaveWarnToday(data) {
  return request({
    type: 'device',
    url: 'exception/inner/count/have/warn/today',
    method: 'post',
    data
  })
}

/**
 * 证件预警分析-证件预警报表全部导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionLicenseBigdataListExport(data) {
  return request({
    type: 'device',
    url: 'exception/license/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 证件预警分析-证件预警报表(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionLicenseBigdataListGet(data) {
  return request({
    type: 'device',
    url: 'exception/license/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 证件预警分析-证件预警报表部分导出
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionLicenseBigdataListOptionExport(data) {
  return request({
    type: 'device',
    url: 'exception/license/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 证件预警分析-今日证件异常统计(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionLicenseBigdataTodayListGet(data) {
  return request({
    type: 'device',
    url: 'exception/license/bigdata/today/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取指示灯异常总数
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionLightTotalGet(data) {
  return request({
    type: 'device',
    url: 'exception/light/total/get',
    method: 'post',
    data
  })
}

/**
 * 业务数据中心-监管设备预警列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionMonitordeviceList(data) {
  return request({
    type: 'device',
    url: 'exception/monitordevice/list',
    method: 'post',
    data
  })
}

/**
 * 获取最新异常信息（食堂层-摄像头级）(WZP)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionNewDeptCameraListGet(data) {
  return request({
    type: 'device',
    url: 'exception/new/dept/camera/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取最新异常信息（食堂层级）(WZP)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionNewDeptListGet(data) {
  return request({
    type: 'device',
    url: 'exception/new/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取最新异常信息（组织层级）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionNewListGet(data) {
  return request({
    type: 'device',
    url: 'exception/new/list/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常类别分类(图标)（无食品）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionNogoodtypeList(data) {
  return request({
    type: 'device',
    url: 'exception/nogoodtype/list',
    method: 'post',
    data
  })
}

/**
 * 一键展示（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionOneClickDisplayGet(data) {
  return request({
    type: 'device',
    url: 'exception/one/click/display/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常承包商分布（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportContranumList(data) {
  return request({
    type: 'device',
    url: 'exception/report/contranum/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-统计组织下食堂的异常信息（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportDeptList(data) {
  return request({
    type: 'device',
    url: 'exception/report/dept/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-统计组织下食堂的详情异常类型（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportDeptdetailtypeList(data) {
  return request({
    type: 'device',
    url: 'exception/report/deptdetailtype/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常食堂分布（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportDeptnumList(data) {
  return request({
    type: 'device',
    url: 'exception/report/deptnum/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常承包商分布(导出Excel)（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportContranumList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/contranum/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-统计组织下食堂的异常信息(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportDeptList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/dept/list',
    method: 'post',
    data
  })
}

/**
 * 统计组织下食堂的详情异常类型(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportDeptdetailtypeList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/deptdetailtype/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常食堂分布(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportDeptnumList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/deptnum/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-月度异常趋势统计(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportMonthtrendList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/monthtrend/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常类别分类（无食品）(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportNogoodtypeList(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/nogoodtype/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-食品安全年统计报表(导出Excel)（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportExportTotalGet(data) {
  return request({
    type: 'device',
    url: 'exception/report/export/total/get',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-月度异常趋势统计（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportMonthtrendList(data) {
  return request({
    type: 'device',
    url: 'exception/report/monthtrend/list',
    method: 'post',
    data
  })
}

/**
 * 报表数据中心-异常类别分类（无食品）（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionReportNogoodtypeList(data) {
  return request({
    type: 'device',
    url: 'exception/report/nogoodtype/list',
    method: 'post',
    data
  })
}

/**
 * 获取食堂异常安全指数（wuzp-20220628）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionSafetyindexDeptGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/dept/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常安全指数食堂列表(App)(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionSafetyindexDeptListGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常安全指数食堂列表(微信)(分页)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionSafetyindexDeptListNotokenGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/dept/list/notoken/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常安全指数（大屏和App）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionSafetyindexScreenAppGet(data) {
  return request({
    type: 'device',
    url: 'exception/safetyindex/screen/app/get',
    method: 'post',
    data
  })
}

/**
 * 数据统计-食堂异常占比（今日/7日）（App）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionStatisticsDepartmentList(data) {
  return request({
    type: 'device',
    url: 'exception/statistics/department/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-异常处置率排行（今日/7日）（App）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionStatisticsHandleRankList(data) {
  return request({
    type: 'device',
    url: 'exception/statistics/handle/rank/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-异常处置率趋势（7日）（App）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionStatisticsHandleTrendList(data) {
  return request({
    type: 'device',
    url: 'exception/statistics/handle/trend/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-异常趋势（7日）（App）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionStatisticsTrendList(data) {
  return request({
    type: 'device',
    url: 'exception/statistics/trend/list',
    method: 'post',
    data
  })
}

/**
 * 数据统计-异常类别占比（今日/7日）（App）（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionStatisticsTypeList(data) {
  return request({
    type: 'device',
    url: 'exception/statistics/type/list',
    method: 'post',
    data
  })
}

/**
 * 根据设备，获取异常列表（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTargetListGet(data) {
  return request({
    type: 'device',
    url: 'exception/target/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日所有食堂的异常信息和指示灯（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayAlldeptInfoGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/alldept/info/get',
    method: 'post',
    data
  })
}

/**
 * 根据运营商、区域、食堂ID楼层ID分页获取当天异常记录（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayCrdlListGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/crdl/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日食堂异常处置未处置统计信息（用途：参考名厨亮灶-食堂异常处置未处置情况）(WZP)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayDeptHandleInfoGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/dept/handle/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取今日食堂异常区域/主要扣分项排名(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayDeptRegionItemList(data) {
  return request({
    type: 'device',
    url: 'exception/today/dept/region/item/list',
    method: 'post',
    data
  })
}

/**
 * 获取今日异常处置未处置统计信息（今日、年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayHandleInfoGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/handle/info/get',
    method: 'post',
    data
  })
}

/**
 * 根据区域分页获取当天异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayListGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据区域、食堂ID和楼层ID分页获取当天异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayRdlListGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/rdl/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据区域和食堂ID分页获取当天异常记录
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayRegiondeptListGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/regiondept/list/get',
    method: 'post',
    data
  })
}

/**
 * 按照食堂分类获取获取今日异常处置未处置统计信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTodayTypeHandleInfoGet(data) {
  return request({
    type: 'device',
    url: 'exception/today/type/handle/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常分类统计信息（今日、年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeAnomaloustypeGroupGet(data) {
  return request({
    type: 'device',
    url: 'exception/type/anomalousType/group/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂指定日期异常分类统计信息（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeAnomaloustypeGroupGetDate(data) {
  return request({
    type: 'device',
    url: 'exception/type/anomalousType/group/get/date',
    method: 'post',
    data
  })
}

/**
 * 获取食堂指定日期异常分类统计信息详情（ch）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeAnomaloustypeGroupGetDetail(data) {
  return request({
    type: 'device',
    url: 'exception/type/anomalousType/group/get/detail',
    method: 'post',
    data
  })
}

/**
 * 按照承包商分类统计异常数据（年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeContraGroupGet(data) {
  return request({
    type: 'device',
    url: 'exception/type/contra/group/get',
    method: 'post',
    data
  })
}

/**
 * 按照食堂分类统计异常数据（年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeDeptGroupGet(data) {
  return request({
    type: 'device',
    url: 'exception/type/dept/group/get',
    method: 'post',
    data
  })
}

/**
 * 按照指定食堂区域分类统计异常数据（年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeMonthGroupGet(data) {
  return request({
    type: 'device',
    url: 'exception/type/month/group/get',
    method: 'post',
    data
  })
}

/**
 * 按照指定食堂区域分类统计异常数据（年份）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeRegionGroupGet(data) {
  return request({
    type: 'device',
    url: 'exception/type/region/group/get',
    method: 'post',
    data
  })
}

/**
 * 设备类型故障排行列表（cme）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionTypeSortList(data) {
  return request({
    type: 'device',
    url: 'exception/type/sort/list',
    method: 'post',
    data
  })
}

/**
 * 异常管理-异常记录（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function exceptionV2ManageList(data) {
  return request({
    type: 'device',
    url: 'exception/v2/manage/list',
    method: 'post',
    data
  })
}

/**
 * 统计组织下各学校/食堂的异常信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcExceptionDeptList(data) {
  return request({
    type: 'device',
    url: 'pc/exception/dept/list',
    method: 'post',
    data
  })
}

/**
 * 月度异常趋势
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcExceptionMonthsTrendGet(data) {
  return request({
    type: 'device',
    url: 'pc/exception/months/trend/get',
    method: 'post',
    data
  })
}

/**
 * 年度异常统计
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function pcExceptionYearCountGet(data) {
  return request({
    type: 'device',
    url: 'pc/exception/year/count/get',
    method: 'post',
    data
  })
}

/**
 * 获取异常信息详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function regionExceptionInfoGet(data) {
  return request({
    type: 'device',
    url: 'region/exception/info/get',
    method: 'post',
    data
  })
}

/**
 * 获取年份列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function yearListGet(data) {
  return request({
    type: 'device',
    url: 'year/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Warning.js